import * as React from "react";
import MapLayoutWithTwoSidebars from "../../Generics/MapLayoutWithTwoSidebars";
import MapContainerWithUiLayers from "../../Generics/MapContainerWithUiLayers";
import SidebarLayout from "../../Generics/SidebarLayout";
import SidebarFooter from "../components/SidebarFooter";
import OverlaySwitchButton from "../../../map/reusableLayers/PrescanLayer/OverlaySwitchButton";
import FitSiteButton from "../../Controls/FitSiteButton/FitSiteButton";
import MapControlsLayout from "../../Generics/MapControlsLayout";
import SidebarVisibilityControl from "../components/SidebarVisibilityControl";
import SatelliteButtonContainer from "../../../map/reusableLayers/WorldLayer/SatelliteButtonContainer";
import GeolocationButton from "../../../map/reusableLayers/GeolocationLayer/GeolocationButton";
import ModeReadonlyGcpRequestLeafletMapContainer from "./ModeReadonlyGcpRequestLeafletMapContainer";
import {
  userClicksShowFlightMarkerLabelsButton,
  userLeavesGcpRequestViewPage,
  userOpensGcpRequestViewPage,
} from "./scenarios";
import { connect } from "react-redux";
import { IGcpAppDispatchProp } from "../../../redux/store";
import ShowFlightMarkerLabelsButton from "../../Controls/ShowFlightMarkerLabelsButton";
import {
  getModeGcpRequestUiState,
  IStoreState,
} from "../../../redux/rootReducer";
import { IModeGcpRequestUi } from "../../../redux/modules/modeGcpRequestUi/reducer";
import * as L from "leaflet";
import { FlightMarkersGuideButton } from "./FlightMarkersGuideButton";

interface IModeReadonlyLayoutProps extends IGcpAppDispatchProp {
  sidebarWidth: number;
  sidebarIsVisible: boolean;
  sidebarHeader: React.JSX.Element[] | React.JSX.Element | null;
  sidebarContent: React.JSX.Element[] | React.JSX.Element | null;
  modeGcpRequestUiState: IModeGcpRequestUi;
}

class ModeReadonlyGcpRequestLayout extends React.Component<
  IModeReadonlyLayoutProps,
  {}
> {
  public componentDidMount() {
    this.props.dispatch(userOpensGcpRequestViewPage());
  }

  public componentWillUnmount() {
    this.props.dispatch(userLeavesGcpRequestViewPage());
  }

  public render() {
    const flightMarkerLabelsButton = (
      <ShowFlightMarkerLabelsButton
        onClick={() =>
          this.props.dispatch(userClicksShowFlightMarkerLabelsButton())
        }
        isOn={this.props.modeGcpRequestUiState.showFlightMarkerLabelsIsOn}
      />
    );
    const isMobile = L.Browser.mobile;

    return (
      <MapLayoutWithTwoSidebars
        left={this.renderLeftSidebar()}
        center={
          <MapContainerWithUiLayers
            mapElement={<ModeReadonlyGcpRequestLeafletMapContainer />}
            uiLayers={[
              <MapControlsLayout
                topLeft={
                  <>
                    <SidebarVisibilityControl />
                    {isMobile === false && flightMarkerLabelsButton}
                  </>
                }
                topRight={<GeolocationButton />}
                bottomLeft={
                  <>
                    <SatelliteButtonContainer />
                    <OverlaySwitchButton />
                  </>
                }
                bottomRight={<FlightMarkersGuideButton />}
              />,
              <MapControlsLayout
                topCenter={
                  <>
                    {isMobile === true && flightMarkerLabelsButton}
                    <FitSiteButton />
                  </>
                }
              />,
            ]}
          />
        }
        right={null}
      />
    );
  }

  private renderLeftSidebar() {
    if (!this.props.sidebarIsVisible) {
      return null;
    }

    return (
      <SidebarLayout
        width={this.props.sidebarWidth}
        top={this.props.sidebarHeader}
        center={this.props.sidebarContent}
        bottom={this.renderFooter()}
      />
    );
  }

  private renderFooter() {
    return <SidebarFooter />;
  }
}

export default connect((state: IStoreState) => ({
  modeGcpRequestUiState: getModeGcpRequestUiState(state),
}))(ModeReadonlyGcpRequestLayout);
